import React from 'react'
import { CSSProperties } from 'react'

export const iconsLib = {
  'clipboard-list': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <rect
        width='8'
        height='4'
        x='8'
        y='2'
        rx='1'
        ry='1'
      />
      <path d='M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2' />
      <path d='M12 11h4' />
      <path d='M12 16h4' />
      <path d='M8 11h.01' />
      <path d='M8 16h.01' />
    </svg>
  ),
  'clipboard-plus': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <rect
        width='8'
        height='4'
        x='8'
        y='2'
        rx='1'
        ry='1'
      />
      <path d='M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2' />
      <path d='M9 14h6' />
      <path d='M12 17v-6' />
    </svg>
  ),
  'chevron-left': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='m15 18-6-6 6-6' />
    </svg>
  ),
  play: (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <polygon points='6 3 20 12 6 21 6 3' />
    </svg>
  ),
  pause: (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <rect
        x='14'
        y='4'
        width='4'
        height='16'
        rx='1'
      />
      <rect
        x='6'
        y='4'
        width='4'
        height='16'
        rx='1'
      />
    </svg>
  ),
  settings: (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z' />
      <circle
        cx='12'
        cy='12'
        r='3'
      />
    </svg>
  ),
  'settings-2': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M20 7h-9' />
      <path d='M14 17H5' />
      <circle
        cx='17'
        cy='17'
        r='3'
      />
      <circle
        cx='7'
        cy='7'
        r='3'
      />
    </svg>
  ),
  'trash-2': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M3 6h18' />
      <path d='M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6' />
      <path d='M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2' />
      <line
        x1='10'
        x2='10'
        y1='11'
        y2='17'
      />
      <line
        x1='14'
        x2='14'
        y1='11'
        y2='17'
      />
    </svg>
  ),
  'package-plus': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M16 16h6' />
      <path d='M19 13v6' />
      <path d='M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14' />
      <path d='m7.5 4.27 9 5.15' />
      <polyline points='3.29 7 12 12 20.71 7' />
      <line
        x1='12'
        x2='12'
        y1='22'
        y2='12'
      />
    </svg>
  ),
  'file-box': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M14.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4' />
      <path d='M14 2v4a2 2 0 0 0 2 2h4' />
      <path d='M3 13.1a2 2 0 0 0-1 1.76v3.24a2 2 0 0 0 .97 1.78L6 21.7a2 2 0 0 0 2.03.01L11 19.9a2 2 0 0 0 1-1.76V14.9a2 2 0 0 0-.97-1.78L8 11.3a2 2 0 0 0-2.03-.01Z' />
      <path d='M7 17v5' />
      <path d='M11.7 14.2 7 17l-4.7-2.8' />
    </svg>
  ),
  files: (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M20 7h-3a2 2 0 0 1-2-2V2' />
      <path d='M9 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h7l4 4v10a2 2 0 0 1-2 2Z' />
      <path d='M3 7.6v12.8A1.6 1.6 0 0 0 4.6 22h9.8' />
    </svg>
  ),
  'file-plus-2': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4' />
      <path d='M14 2v4a2 2 0 0 0 2 2h4' />
      <path d='M3 15h6' />
      <path d='M6 12v6' />
    </svg>
  ),
  'triangle-alert': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3' />
      <path d='M12 9v4' />
      <path d='M12 17h.01' />
    </svg>
  ),
  'shopping-basket': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='m15 11-1 9' />
      <path d='m19 11-4-7' />
      <path d='M2 11h20' />
      <path d='m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4' />
      <path d='M4.5 15.5h15' />
      <path d='m5 11 4-7' />
      <path d='m9 11 1 9' />
    </svg>
  ),
  'timer-reset': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M10 2h4' />
      <path d='M12 14v-4' />
      <path d='M4 13a8 8 0 0 1 8-7 8 8 0 1 1-5.3 14L4 17.6' />
      <path d='M9 17H4v5' />
    </svg>
  ),
  'calendar-clock': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5' />
      <path d='M16 2v4' />
      <path d='M8 2v4' />
      <path d='M3 10h5' />
      <path d='M17.5 17.5 16 16.3V14' />
      <circle
        cx='16'
        cy='16'
        r='6'
      />
    </svg>
  ),
  eraser: (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21' />
      <path d='M22 21H7' />
      <path d='m5 11 9 9' />
    </svg>
  ),
  'clock-arrow-down': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M12.338 21.994A10 10 0 1 1 21.925 13.227' />
      <path d='M12 6v6l2 1' />
      <path d='m14 18 4 4 4-4' />
      <path d='M18 14v8' />
    </svg>
  ),
  eye: (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0' />
      <circle
        cx='12'
        cy='12'
        r='3'
      />
    </svg>
  ),
  'eye-closed': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='m15 18-.722-3.25' />
      <path d='M2 8a10.645 10.645 0 0 0 20 0' />
      <path d='m20 15-1.726-2.05' />
      <path d='m4 15 1.726-2.05' />
      <path d='m9 18 .722-3.25' />
    </svg>
  ),
  'users-round': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M18 21a8 8 0 0 0-16 0' />
      <circle
        cx='10'
        cy='8'
        r='5'
      />
      <path d='M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3' />
    </svg>
  ),
  'sliders-horizontal': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <line
        x1='21'
        x2='14'
        y1='4'
        y2='4'
      />
      <line
        x1='10'
        x2='3'
        y1='4'
        y2='4'
      />
      <line
        x1='21'
        x2='12'
        y1='12'
        y2='12'
      />
      <line
        x1='8'
        x2='3'
        y1='12'
        y2='12'
      />
      <line
        x1='21'
        x2='16'
        y1='20'
        y2='20'
      />
      <line
        x1='12'
        x2='3'
        y1='20'
        y2='20'
      />
      <line
        x1='14'
        x2='14'
        y1='2'
        y2='6'
      />
      <line
        x1='8'
        x2='8'
        y1='10'
        y2='14'
      />
      <line
        x1='16'
        x2='16'
        y1='18'
        y2='22'
      />
    </svg>
  ),
  percent: (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <line
        x1='19'
        x2='5'
        y1='5'
        y2='19'
      />
      <circle
        cx='6.5'
        cy='6.5'
        r='2.5'
      />
      <circle
        cx='17.5'
        cy='17.5'
        r='2.5'
      />
    </svg>
  ),
  'file-chart-line': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z' />
      <path d='M14 2v4a2 2 0 0 0 2 2h4' />
      <path d='m16 13-3.5 3.5-2-2L8 17' />
    </svg>
  ),
  'file-chart-pie': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M14 2v4a2 2 0 0 0 2 2h4' />
      <path d='M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3.5' />
      <path d='M4.017 11.512a6 6 0 1 0 8.466 8.475' />
      <path d='M9 16a1 1 0 0 1-1-1v-4c0-.552.45-1.008.995-.917a6 6 0 0 1 4.922 4.922c.091.544-.365.995-.917.995z' />
    </svg>
  ),
  'star-half': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M12 18.338a2.1 2.1 0 0 0-.987.244L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16l2.309-4.679A.53.53 0 0 1 12 2' />
    </svg>
  ),
  star: (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z' />
    </svg>
  ),
  'message-square-text': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z' />
      <path d='M13 8H7' />
      <path d='M17 12H7' />
    </svg>
  ),
  'russian-ruble': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M6 11h8a4 4 0 0 0 0-8H9v18' />
      <path d='M6 15h8' />
    </svg>
  ),
  tag: (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z' />
      <circle
        cx='7.5'
        cy='7.5'
        r='.5'
        fill='currentColor'
      />
    </svg>
  ),
  'clipboard-copy': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <rect
        width='8'
        height='4'
        x='8'
        y='2'
        rx='1'
        ry='1'
      />
      <path d='M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2' />
      <path d='M16 4h2a2 2 0 0 1 2 2v4' />
      <path d='M21 14H11' />
      <path d='m15 10-4 4 4 4' />
    </svg>
  ),
  paperclip: (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M13.234 20.252 21 12.3' />
      <path d='m16 6-8.414 8.586a2 2 0 0 0 0 2.828 2 2 0 0 0 2.828 0l8.414-8.586a4 4 0 0 0 0-5.656 4 4 0 0 0-5.656 0l-8.415 8.585a6 6 0 1 0 8.486 8.486' />
    </svg>
  ),
  x: (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M18 6 6 18' />
      <path d='m6 6 12 12' />
    </svg>
  ),
  'square-arrow-out-up-right': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6' />
      <path d='m21 3-9 9' />
      <path d='M15 3h6v6' />
    </svg>
  ),
  'badge-percent': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z' />
      <path d='m15 9-6 6' />
      <path d='M9 9h.01' />
      <path d='M15 15h.01' />
    </svg>
  ),
  'package-open': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M12 22v-9' />
      <path d='M15.17 2.21a1.67 1.67 0 0 1 1.63 0L21 4.57a1.93 1.93 0 0 1 0 3.36L8.82 14.79a1.655 1.655 0 0 1-1.64 0L3 12.43a1.93 1.93 0 0 1 0-3.36z' />
      <path d='M20 13v3.87a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13' />
      <path d='M21 12.43a1.93 1.93 0 0 0 0-3.36L8.83 2.2a1.64 1.64 0 0 0-1.63 0L3 4.57a1.93 1.93 0 0 0 0 3.36l12.18 6.86a1.636 1.636 0 0 0 1.63 0z' />
    </svg>
  ),
  megaphone: (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='m3 11 18-5v12L3 14v-3z' />
      <path d='M11.6 16.8a3 3 0 1 1-5.8-1.6' />
    </svg>
  ),
  'arrow-big-down-dash': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M15 5H9' />
      <path d='M15 9v3h4l-7 7-7-7h4V9z' />
    </svg>
  ),
  rocket: (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z' />
      <path d='m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z' />
      <path d='M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0' />
      <path d='M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5' />
    </svg>
  ),
  'list-restart': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M21 6H3' />
      <path d='M7 12H3' />
      <path d='M7 18H3' />
      <path d='M12 18a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L11 14' />
      <path d='M11 10v4h4' />
    </svg>
  ),
  'refresh-ccw': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8' />
      <path d='M3 3v5h5' />
      <path d='M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16' />
      <path d='M16 16h5v5' />
    </svg>
  ),
  filter: (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <polygon points='22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3' />
    </svg>
  ),
  'chart-network': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='m13.11 7.664 1.78 2.672' />
      <path d='m14.162 12.788-3.324 1.424' />
      <path d='m20 4-6.06 1.515' />
      <path d='M3 3v16a2 2 0 0 0 2 2h16' />
      <circle
        cx='12'
        cy='6'
        r='2'
      />
      <circle
        cx='16'
        cy='12'
        r='2'
      />
      <circle
        cx='9'
        cy='15'
        r='2'
      />
    </svg>
  ),
  'file-chart-column-increasing': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z' />
      <path d='M14 2v4a2 2 0 0 0 2 2h4' />
      <path d='M8 18v-2' />
      <path d='M12 18v-4' />
      <path d='M16 18v-6' />
    </svg>
  ),
  crosshair: (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <circle
        cx='12'
        cy='12'
        r='10'
      />
      <line
        x1='22'
        x2='18'
        y1='12'
        y2='12'
      />
      <line
        x1='6'
        x2='2'
        y1='12'
        y2='12'
      />
      <line
        x1='12'
        x2='12'
        y1='6'
        y2='2'
      />
      <line
        x1='12'
        x2='12'
        y1='22'
        y2='18'
      />
    </svg>
  ),
  signal: (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M2 20h.01' />
      <path d='M7 20v-4' />
      <path d='M12 20v-8' />
      <path d='M17 20V8' />
      <path d='M22 4v16' />
    </svg>
  ),
  network: (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <rect
        x='16'
        y='16'
        width='6'
        height='6'
        rx='1'
      />
      <rect
        x='2'
        y='16'
        width='6'
        height='6'
        rx='1'
      />
      <rect
        x='9'
        y='2'
        width='6'
        height='6'
        rx='1'
      />
      <path d='M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3' />
      <path d='M12 12V8' />
    </svg>
  ),
  'text-search': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M21 6H3' />
      <path d='M10 12H3' />
      <path d='M10 18H3' />
      <circle
        cx='17'
        cy='15'
        r='3'
      />
      <path d='m21 19-1.9-1.9' />
    </svg>
  ),
  search: (style = {}) => (
    <svg
      style={style}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21 21.0002L16.7 16.7002M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  ),
  'undo-2': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path d='M9 14 4 9l5-5' />
      <path d='M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11' />
    </svg>
  ),
  'book-copy': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path d='M2 16V4a2 2 0 0 1 2-2h11' />
      <path d='M22 18H11a2 2 0 1 0 0 4h10.5a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5H11a2 2 0 0 0-2 2v12' />
      <path d='M5 14H4a2 2 0 1 0 0 4h1' />
    </svg>
  ),
  boxes: (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path d='M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z' />
      <path d='m7 16.5-4.74-2.85' />
      <path d='m7 16.5 5-3' />
      <path d='M7 16.5v5.17' />
      <path d='M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z' />
      <path d='m17 16.5-5-3' />
      <path d='m17 16.5 4.74-2.85' />
      <path d='M17 16.5v5.17' />
      <path d='M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z' />
      <path d='M12 8 7.26 5.15' />
      <path d='m12 8 4.74-2.85' />
      <path d='M12 13.5V8' />
    </svg>
  ),
  check: (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      strokeWidth={6}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path d='M20 6 9 17l-5-5' />
    </svg>
  ),
  'book-open-text': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      strokeWidth={2}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path d='M12 7v14' />
      <path d='M16 12h2' />
      <path d='M16 8h2' />
      <path d='M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z' />
      <path d='M6 12h2' />
      <path d='M6 8h2' />
    </svg>
  ),
  'cloud-alert': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      strokeWidth={2}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M12 12v4' />
      <path d='M12 20h.01' />
      <path d='M17 18h.5a1 1 0 0 0 0-9h-1.79A7 7 0 1 0 7 17.708' />
    </svg>
  ),
  hash: (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      strokeWidth={2}
      viewBox='0 0 24 24'
      fill='none'
    >
      <line
        x1='4'
        x2='20'
        y1='9'
        y2='9'
      />
      <line
        x1='4'
        x2='20'
        y1='15'
        y2='15'
      />
      <line
        x1='10'
        x2='8'
        y1='3'
        y2='21'
      />
      <line
        x1='16'
        x2='14'
        y1='3'
        y2='21'
      />
    </svg>
  ),
  'server-off': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M7 2h13a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5' />
      <path d='M10 10 2.5 2.5C2 2 2 2.5 2 5v3a2 2 0 0 0 2 2h6z' />
      <path d='M22 17v-1a2 2 0 0 0-2-2h-1' />
      <path d='M4 14a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16.5l1-.5.5.5-8-8H4z' />
      <path d='M6 18h.01' />
      <path d='m2 2 20 20' />
    </svg>
  ),
  server: (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <rect
        width='20'
        height='8'
        x='2'
        y='2'
        rx='2'
        ry='2'
      />
      <rect
        width='20'
        height='8'
        x='2'
        y='14'
        rx='2'
        ry='2'
      />
      <line
        x1='6'
        x2='6.01'
        y1='6'
        y2='6'
      />
      <line
        x1='6'
        x2='6.01'
        y1='18'
        y2='18'
      />
    </svg>
  ),
  archive: (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <rect
        width='20'
        height='5'
        x='2'
        y='3'
        rx='1'
      />
      <path d='M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8' />
      <path d='M10 12h4' />
    </svg>
  ),
  'archive-restore': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <rect
        width='20'
        height='5'
        x='2'
        y='3'
        rx='1'
      />
      <path d='M4 8v11a2 2 0 0 0 2 2h2' />
      <path d='M20 8v11a2 2 0 0 1-2 2h-2' />
      <path d='m9 15 3-3 3 3' />
      <path d='M12 12v9' />
    </svg>
  ),
  factory: (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M12 16h.01' />
      <path d='M16 16h.01' />
      <path d='M3 19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.5a.5.5 0 0 0-.769-.422l-4.462 2.844A.5.5 0 0 1 15 10.5v-2a.5.5 0 0 0-.769-.422L9.77 10.922A.5.5 0 0 1 9 10.5V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2z' />
      <path d='M8 16h.01' />
    </svg>
  ),
  'calendar-arrow-down': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='m14 18 4 4 4-4' />
      <path d='M16 2v4' />
      <path d='M18 14v8' />
      <path d='M21 11.354V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.343' />
      <path d='M3 10h18' />
      <path d='M8 2v4' />
    </svg>
  ),
  'calendar-arrow-up': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='m14 18 4-4 4 4' />
      <path d='M16 2v4' />
      <path d='M18 22v-8' />
      <path d='M21 11.343V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9' />
      <path d='M3 10h18' />
      <path d='M8 2v4' />
    </svg>
  ),
  wifi: (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M12 20h.01' />
      <path d='M2 8.82a15 15 0 0 1 20 0' />
      <path d='M5 12.859a10 10 0 0 1 14 0' />
      <path d='M8.5 16.429a5 5 0 0 1 7 0' />
    </svg>
  ),
  'wifi-off': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M12 20h.01' />
      <path d='M8.5 16.429a5 5 0 0 1 7 0' />
      <path d='M5 12.859a10 10 0 0 1 5.17-2.69' />
      <path d='M19 12.859a10 10 0 0 0-2.007-1.523' />
      <path d='M2 8.82a15 15 0 0 1 4.177-2.643' />
      <path d='M22 8.82a15 15 0 0 0-11.288-3.764' />
      <path d='m2 2 20 20' />
    </svg>
  ),
  'image-down': (style = {}) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      viewBox='0 0 24 24'
      strokeWidth='1'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21' />
      <path d='m14 19 3 3v-5.5' />
      <path d='m17 22 3-3' />
      <circle
        cx='9'
        cy='9'
        r='2'
      />
    </svg>
  ),
}

export type Icons = keyof typeof iconsLib
export interface IIconOptions {
  width?: string
  height?: string
  fill?: string
  stroke?: string
  opacity?: string
}

export const icons = (type: Icons, options?: IIconOptions) =>
  iconsLib[type]({
    width: options?.width || '24px',
    height: options?.height || options?.width || '24px',
    fill: options?.fill || 'none',
    stroke: options?.stroke || 'currentColor',
    opacity: options?.opacity || '1',
  } as CSSProperties)
